import axios from "axios";
import { USER_ID } from "../../../../utils/constants";

const BASE_URL =
  "https://9kre7duqx7.execute-api.ap-south-1.amazonaws.com/default";

export const subscribeClient = axios.create({
  baseURL: BASE_URL,
});

export const subscribeToReports = async (
  user_id,
  subscriptionType,
  mobile = null
) => {
  try {
    const payload = {
      user_id: USER_ID,
      type: subscriptionType,
    };

    if (mobile) {
      payload.mobile = mobile;
    }

    const response = await subscribeClient.post("/subscribeToReports", payload);
    return response.data;
  } catch (error) {
    console.error("Error subscribing:", error);
    throw error;
  }
};
